import { render } from "./Home.vue?vue&type=template&id=6bb12951&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=6bb12951&lang=scss&scoped=true"

import exportComponent from "/home/irevors/CODING/ESTUDIOS/SENCE/ensayo prueba TD/ensayo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb12951"]])

export default __exports__